import { render, staticRenderFns } from "./StatusSearch.vue?vue&type=template&id=707654a1"
import script from "./StatusSearch.vue?vue&type=script&lang=js"
export * from "./StatusSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports